const autoNgTemplateLoaderTemplate1 = require('./devices-panel.html');

angular.module('portainer.docker').component('devicesPanel', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    devices: '<',
  },
});
